<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<div class="flex">

  @if(chartVisible){
  <div class="border-2 border-solid border-blue-800 w-[810px]">
    <!-- <app-stock-kline [stockno]="stockno">
    </app-stock-kline> -->
    <app-jkbbchart [stockno]="stockno">

    </app-jkbbchart>
  </div>
  }
  <div class="w-full">
    <mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
      <mat-tab #myTabGrid label="條件設定">
        <mat-toolbar class="h-9">
          <button class="btn" [class.btn-primary]="true" (click)="doQuery()">
            <mat-icon fontIcon="search"></mat-icon>查詢
          </button>
          <button class="btn" [class.btn-info]="true" (click)="doGetPreFilter()">
            <mat-icon fontIcon="search"></mat-icon>取前次
          </button>
          <button class="btn" (click)="toggleChartVisible()">切換走勢圖</button>

        </mat-toolbar>
        <div class="jk-grid-cols-3">

          <app-jkdaterange #stkmm004 label="日期" [(valueA)]="filterOpt.date1" [(valueB)]="filterOpt.date2"
            [showClearButton]="true" [required]="true">
          </app-jkdaterange>
          <app-jkbtnedit #stkme001 label="群組" [showClearButton]="true" [required]="true" maintable="STKME" item="W01"
            valueExpr="ME001" displayExpr="ME002" [(value)]="groupno">
          </app-jkbtnedit>
          <app-jkmultiselect #stkmm003 maintable="STKMA" item="W01" label="商品代號" valueExpr="MA001" displayExpr="MA002"
            [required]="true" [(values)]="filterOpt.stkmm003">
          </app-jkmultiselect>
          <app-jkmultiselect #stkmm002 maintable="STKMJ" item="W01" label="條件代號" valueExpr="MJ002" displayExpr="MJ003"
            [(values)]="filterOpt.stkmm002">
          </app-jkmultiselect>
          <app-jkcombobox #stklg039 label="季線(SMA60)-方向" [(value)]="filterOpt.stklg039" [items]="stklg039List"
            [disabled]="true">
          </app-jkcombobox>

          <app-jkcombobox #stklg002 label="資料頻率" [(value)]="filterOpt.frequency" [items]="stklg002List"
            [disabled]="true">
          </app-jkcombobox>
          <app-jkcombobox #orderby label="排序方式" [value]="filterOpt.order" [items]="orderList">
          </app-jkcombobox>
        </div>
      </mat-tab>
      <mat-tab #myTabDetail label="詳細資料">
        <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event)" (rowClicked)="agRowClicked($event)">
        </app-jkgridwin>
      </mat-tab>
    </mat-tab-group>
  </div>

</div>
